import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'

import { env } from '@/config/env'

/**
 * Cutover controlado de GOVIA UI V2 (autorizado). Único punto de decisión
 * para las 2 rutas que de verdad colisionan entre V1 y V2 ('/' y
 * '/govia-ai' — ver auditoría de Fase 9, sección 1: son las únicas 2 rutas
 * V2 objetivo que ya tenían contenido V1 en el mismo path). El resto de
 * `/territorio`/`/estrategia` no lo necesitan: no tienen V1 en esa ruta
 * exacta, así que sirven V2 siempre.
 *
 * Default seguro (sección 2 del encargo de cutover): CUALQUIER valor de
 * `VITE_GOVIA_UI_VERSION` distinto de exactamente `'v2'` — incluida la
 * variable ausente — sirve V1 (`children`). Nunca al revés.
 */
export function VersionGate({ v2Path, children }: { v2Path: string; children: ReactNode }) {
  if (env.uiDefaultVersion === 'v2') {
    return <Navigate to={v2Path} replace />
  }
  return children
}
